import {
  Component,
  inject,
  Input,
  OnInit,
  NO_ERRORS_SCHEMA,
  Output,
  EventEmitter
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { split, find, includes, set, get } from "lodash-es";
import { BaseComponent } from "@wms/components";
import { PropertiesTemplateComponent } from "../../properties-template.component";
import { CommonWidgetDirective } from "@wms/directives";

@Component({
  selector: 'wms-box-model',
  standalone: true,
  imports: [CommonModule, FormsModule, CommonWidgetDirective],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './box-model.component.html',
  styleUrls: ['./box-model.component.less']
})
export class BoxModelComponent extends BaseComponent implements OnInit{

  @Input() property: string;
  dataVal: any;
  _model: any = {};
  _errors: any = {};
  errors=0;
  _origModel = ''
  regex = /%|px|em|pt/;
  UNSET = 'unset';

  @Output() onChange:EventEmitter<any> = new EventEmitter();
  protected isNativeMobileApplicationType: boolean;

  constructor() {
    super();
    this.isNativeMobileApplicationType = this.projectService.isNativeMobileApplicationType();
  }

  get dataValue(){
    return this.dataVal;
  }
  @Input() set dataValue(val: any){
    this.dataVal = val;
    this.watch(this.dataVal)
  }
  ngOnInit(): void {
  }

  splitIntoParts(model: any) {
    this._origModel = model;
    let parts = split(model, ' ');

    if (parts.length === 1) {
      parts.push(parts[0], parts[0], parts[0]);
    }
    else if (parts.length === 2) {
      parts.push(parts[0], parts[1]);
    }

    this._model.top = this.toValid(parts[0]);
    this._model.right = this.toValid(parts[1]);
    this._model.bottom = this.toValid(parts[2]);
    this._model.left = this.toValid(parts[3]);
    this._model.unit = this.getUnitsFromVal(parts);
  }

  watch(e: string) {
    this.splitIntoParts(e);
  }

  triggerOnChange() {
    let updatedModel = this.getUpdatedModelOnChange();
    if (updatedModel != this._origModel) {
      this.onChange.emit(updatedModel);
    }
  }

  isValid(val: any):boolean {
    return +val == val;
  }

  updateErrorStatus(key?:string,bool?:boolean) {
    let errorStatus = 0;
    if(bool){
      this.errors = 1;
      set(this, '_errors.' + key, true);
      return;
    }
    else {
      set(this, '_errors.' + key,false);
      for (let i = 0;i<Object.keys(this._errors).length;i++){
        if (get(this._errors,Object.keys(this._errors)[i])==true)
          return;
      }
    }
    this.errors = 0;
    this._errors = {};
    return;
  }

  _onChange(key: string, val: any) {
    if (!this.isValid(val)) {
      this.updateErrorStatus(key,true);
      return;
    }
    if(get(this._errors, key)){
      this.updateErrorStatus(key,false);
    }
    this.triggerOnChange();
  }

  toValid(val: any) {
    if (!val) {
      return;
    }
    if (val === this.UNSET) {
      return;
    }
    const _val = val.replace(this.regex, '');
    if (!_val) {
      return;
    }
    return _val;
  }

  getUnitsFromVal(vals: string[]) {
    let val = find(vals, v => {
      return v.indexOf(this.UNSET) === -1
    });
    if (!val || includes(val, 'px')) {
      return 'px';
    }
    if (includes(val, '%')) {
      return '%';
    }
    if (includes(val, 'em')) {
      return 'em';
    }
    if (includes(val, 'pt')) {
      return 'pt';
    }
    return 'px';
  }

  getUpdatedModelOnChange() {
    let unit = this._model.unit || 'px',
      top = this._model.top,
      right = this._model.right,
      bottom = this._model.bottom,
      left = this._model.left,
      expr;

    top = top ? top + unit : this.UNSET;
    right = right ? right + unit : this.UNSET;
    bottom = bottom ? bottom + unit : this.UNSET;
    left = left ? left + unit : this.UNSET;

    if (top === bottom && left === right) {
      if (top === left) {
        expr = top;
      } else {
        expr = top + ' ' + left;
      }
    } else {
      expr = top + ' ' + right + ' ' + bottom + ' ' + left;
    }

    if (expr === this.UNSET) {
      return;
    }

    return expr;
  }

  _onUnitChange(){
    this.triggerOnChange();
  }

  setActiveProperty(property: string) {
    this.eventManager.emitsetActiveprop(property);
  }

}
